'use strict';

var INVOICE = 'INVOICE';

exports.INVOICE = INVOICE;
